import React, { useState } from 'react';
import CodeSentIcon from '../Assets/SVG/codeSentIcon';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';

const CodeInsert = (props) => {
  const [idCode, setIdCode] = useState('');
  const [errorInForm, setErrorForm] = useState(null);

  const validateCode = async () => {
    if (idCode == '') {
      setErrorForm('אנא הזן קוד');
      return false;
    }
    let isRightCode = await props.onclick(idCode);

    if (!isRightCode) {
      setErrorForm('יש טעות בקוד, שננסה שוב?');
    }
  };
  return (
    <div className='screenContainer'>
      <form action="#" onSubmit={async (e) => {
        e.preventDefault();
        await validateCode();
      }}>
        <CodeSentIcon />
        <h3 className='heading'>מה קוד הזיהוי שהגדרת?</h3>
        <TextInput
          placeholder={'קוד זיהוי'}
          value={idCode}
          error={errorInForm}
          onChange={(e) => {
            setIdCode(e.target.value);
            setErrorForm(null);
          }}
        />
        <Footer onclick={(() => { })} stage={props.stage} />

      </form>
    </div>
  );
};

export default CodeInsert;
